export * from './atoms';
export * from './organisms';
export * from './model';

import { ListAtoms } from './atoms';
import { ListOrganisms } from './organisms';

export const ListComponents = [
    ...ListAtoms,
    ...ListOrganisms
];